import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AskResponseGpt, DetailsResponse, GetDocumentResponse } from '../domain/models/gpt';

@Injectable({ providedIn: 'root' })
export class AdapterService {
  private gptUrl = environment.apiEndpoint;
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  askGpt(body: any) {
    return this.http.post<AskResponseGpt>(
      this.gptUrl + 'v1/IA/openai-response',
      JSON.stringify(body),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Skip-Loading': 'true'
        })
      }
    );
  }

  downloadDocument(body: any) {
    return this.http.post<DetailsResponse<GetDocumentResponse>>(
      this.gptUrl + 'v1/IA/get-blob',
      JSON.stringify(body),
      this.httpOptions
    );
  }

  getHistory(body) {
    return this.http.post<any>(
      this.gptUrl + 'v1/IA/get-history',
      JSON.stringify(body),
      this.httpOptions
    );
  }

  getConversation(body: any) {
    return this.http.post<any>(
      this.gptUrl + 'v1/IA/get-conversation',
      JSON.stringify(body),
      this.httpOptions
    );
  }

  updateConversation(
    body: any
  ) {
    return this.http.post<any>(
      this.gptUrl + 'v1/IA/update-conversation',
      JSON.stringify(body),
      this.httpOptions
    );
  }

  rateAnswer(body: any) {
    return this.http.post<any>(
      this.gptUrl + 'v1/IA/rate-answer',
      JSON.stringify(body),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Skip-Loading': 'true'
        })
      }
    );
  }

  createComment(body: { UserId: number; Comment: string }) {
    return this.http.post<any>(
      this.gptUrl + 'v1/Comments/create-comment',
      JSON.stringify(body),
      this.httpOptions
    );
  }
  
  exportConversationToPdf(body: any) {
    return this.http.post(
      this.gptUrl + 'v1/IA/export-conversation-pdf',
      body,
      {
        ...this.httpOptions,
        responseType: 'blob' as 'json'
      }
    );
  }

  shareConversation(body: any) {
    return this.http.post<any>(
      this.gptUrl + 'v1/IA/share',
      JSON.stringify(body),
      this.httpOptions
    );
  }
}